"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  /** Get cached value by key
  * @param {string} key - Cache key
  * @returns {Object} - Cache value
  */
  get(key) {
    return localStorage.getItem(key);
  },

  /** Sets cache value by key
  * @param {string} key - Cache key
  * @param {string} value - Cache value
  */
  set(key, value) {
    localStorage.setItem(key, value);
  },

  /** Clears cached value by key
  * @param {string} key - Cache key
  */
  clear(key) {
    localStorage.removeItem(key);
  },

  /**
   * Clears all the cache items
  */
  clearAll() {
    localStorage.clearAll();
  }

};
exports.default = _default;